import React from 'react'
import moment from 'moment'
import { List, Snackbar, useListRepository } from 'elentari'
import { useAbility } from '../Usuarios'
import { getListActions } from '../../lib/crudAuthorization'
import tarefaRepository from './tarefaRepository'
import { useLocation } from 'react-router-dom'
import abbreviate from 'abbreviate-name'
import { TarefaBadgeStatus } from './TarefaStatus'
import TarefaFilter from './Filters/TarefaFilter'
import { formatNomeUsuario } from '../../utils/Formatter'
import relatoriosRepository from '../Relatorios/RelatoriosRepository'
import { fromPairs } from 'ramda'

const listOptions = {
  defaultOrder: 'createdAt desc',
  fields: {
    id: {
      label: 'Id'
    },
    createdAt: {
      label: 'Data Criação',
      format: data => moment(data).format('DD/MM/YYYY HH:mm'),
      align: 'center'
    },
    responsavel: {
      label: 'Responsável',
      format: data => abbreviate(data ? data.nome : '')
    },
    ordemCarregamento: {
      label: 'Ordem de Carregamento'
    },
    cpfMotorista: {
      label: 'CPF'
    },
    nomeMotorista: {
      label: 'Motorista',
      format: nomeMotorista => (nomeMotorista ? abbreviate(nomeMotorista) : '')
    },
    placaCavalo: {
      label: 'Placa'
    },
    centroCusto: {
      label: 'Centro de Custo',
      format: centroCusto => (centroCusto ? centroCusto.descricao : '-')
    },
    mercadoria: {
      label: 'Mercadoria',
      format: mercadoria => (mercadoria ? mercadoria.descricao : '-')
    },
    status: {
      label: 'Status',
      format: value => <TarefaBadgeStatus status={value} />
    },
    embarcador: {
      label: 'Embarcador',
      format: formatNomeUsuario,
      noOrder: true
    },
    dataTermino: {
      label: 'Data Término',
      format: data => (data ? moment(data).format('DD/MM/YYYY HH:mm') : '-'),
      align: 'center'
    },
    empresa: {
      label: 'Empresa',
      format: empresa => (empresa ? empresa.sigla : '-'),
      noOrder: true,
      align: 'center'
    }
  }
}

const Tarefa = props => {
  const [ability] = useAbility()
  const [mensagem, setMensagem] = React.useState('')
  const location = useLocation()
  const listHook = useListRepository({
    repository: tarefaRepository,
    defaultSort: 'createdAt desc',
    path: 'tarefa'
  })

  const actions = getListActions(ability, listHook, 'tarefa')

  const onDownloadClick = async () => {
    setMensagem('Preparando a criação do relatório')
    const params = new URLSearchParams(location.search)
    const { page, rows, sort = 'createdAt desc', ...allQuery } = fromPairs([
      ...params.entries()
    ])
    const response = await relatoriosRepository.criarRelatorioTarefas({
      query: {
        ...allQuery,
        ...(sort ? { sort } : {})
      }
    })
    if (!response.ok) {
      setMensagem(
        response.data.error.message || 'Falha na criação do relatório'
      )
    } else {
      setTimeout(() => {
        setMensagem(
          'O Download será liberado na página de Relatórios assim que ficar pronto, qualquer problema entre em contato com o suporte!'
        )
      }, 2000)
    }
  }

  return (
    <>
      <TarefaFilter />
      <List
        {...props}
        {...listHook}
        {...actions}
        stickyHeader
        adjustToScreenHeight
        onClickView={null}
        onClickEdit={null}
        onClickRow={item => props.history.push(`/tarefa/${item.id}`)}
        removeItem={null}
        onDownloadClick={onDownloadClick}
        listOptions={listOptions}
      />
      <Snackbar message={mensagem} onClose={() => setMensagem('')} />
    </>
  )
}

export default Tarefa
